module.exports = __webpack_public_path__ + "static/media/upload.f897cb3d.svg";